import { useQuery } from "react-query";
import Select from "react-select"
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
  Heading,
  Highlight,
  Image,
  ImageCaption,
  ImageResize,
  ImageStyle,
  ImageToolbar,
  LinkImage,
  FontSize,
  FontFamily,
  FontBackgroundColor,
  FontColor,
  BlockQuote,
  Underline,
  ImageUpload,
  

  
} from "ckeditor5";

import { getCategories } from "../../../../../MyApi/sb/categories";

import LoadingSpinner from "../../../../UI/spinner"
import icons from "../../../../../Data/icons";

import classes from "./addCompanies.module.css";
import "ckeditor5/ckeditor5.css";
const EditArticles = ({

  setActive, active,  name , setName , setDescription , description ,setCategoryId ,setImage,categoryId ,image
  
}) => {

  const {data,isLoading} = useQuery("getcategory" , getCategories)

  const Abc = icons.abc
  const Description = icons.description

  const categories = data?.data || []
const defaultCategory = categories.find((option=> option.id ===categoryId))
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleDesChange = (event , editor) => {
    const data =editor.getData()

    setDescription(data);
  };
  const handelCategoryChange =(selectedOption)=>{
    const categoryId = selectedOption ? selectedOption.id :0 
    setCategoryId(categoryId)
  }
  const handelImageChange=(e)=>{
    const file = e.target.files[0]
    setImage(file)
  }
  const handleActiveChange =(e)=>{
    const isChecked =e.target.checked
   setActive(isChecked ?1 :0)
  }

if(isLoading){
  return <LoadingSpinner/>
}
  return (
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم المقالة</label>
          <div className={classes.iconInput}>
            <Abc />
          </div>
          <input
            type="text"
            placeholder="ادخل اسم المقالات"
            value={name}
             onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> الوصف </label>
         {description&& <CKEditor
            editor={ClassicEditor}
            config={{
              toolbar: {
                items: [
                  "undo",
                  "redo",
                  "|",
                  "bold",
                  "italic",
                  "underline",
                  "fontSize",
                  "fontFamily",
                  "fontColor",
                  "paragraph",
                  "heading",                
                  "blockQuote",
                  "imageUpload",
                  "link",
                  "image",
                  "imageCaption",
                  "imageResize",
                  "imageStyle",
                  "imageToolbar",
            
            
                ],
              },
              plugins: [
                Bold,
                Essentials,
                Italic,
                Mention,
                Paragraph,
                Undo,
                Heading,
                Highlight,
                Image,
                ImageUpload,
                ImageCaption,
                ImageResize,
                ImageStyle,
                ImageToolbar,
                LinkImage,
                FontSize,
                FontFamily,
                FontBackgroundColor,
                FontColor,
                BlockQuote,
                Underline,
             
              ],
              licenseKey: "<YOUR_LICENSE_KEY>",
              mention: {
                // Mention configuration
              },

         
            }}
            //   onReady={ ( editor ) => {
            //     if ( editorToolbarRef.current ) {
            //         editorToolbarRef.current.appendChild( editor.ui.view.toolbar.element );
            //     }
            // }}
         
           onChange={handleDesChange}
            data={description}
            />}
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> الوصف </label>

          <Select
            type="text"
            placeholder="اختار الفئه"
            getOptionValue={(e)=>e.id} 
            getOptionLabel={(e)=>e.name}    
            options={categories}     
            value={defaultCategory}
             onChange={handelCategoryChange}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> الصورة </label>
          <input
            type="file"
            className={classes.inputCustom}
             onChange={handelImageChange}
          />
          <img src={image} alt="image"  className="img-fluid"/>
        </div>
        <div className={classes.formCol}>
          <label htmlFor="active"  className={active ? `${classes.active}` : `${classes.disActive}`}>   {active===1 ?" نشط":"غير نشط"} </label>
         
         <label class="switch">
          <input type="checkbox" onChange={handleActiveChange} checked={active}/>
            <span class="slider round"></span>
        </label>  
           </div>

     
      </div>
    </div>
  );
};

export default EditArticles;
